module.exports = __webpack_public_path__ + "264cbb8272b821d4be8619ad4ce1b8f6.jpg";